import React, { Fragment, useEffect, useState, useRef } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { academyusergetdetail, menuList } from "../../../services/admin";

let history = [];

const SideBar = () => {
  const location = useLocation();
  const [menuitems, setMenuitems] = useState();
  const [menu, setMenu] = useState();
  const [elogo, setElogo] = useState("");

  const scrollRef = useRef(null);

  // Menus that exist in the DB but should stay hidden from the sidebar.
  // Matched by title or by path prefix on the item and its children.
  const BLOCKED_MENU_TITLES = ["Income and Expenses"];
  const BLOCKED_PATH_PREFIXES = ["/incomeandexpense"];

  function isBlockedMenu(item) {
    if (!item) return false;
    if (BLOCKED_MENU_TITLES.includes(item.title)) return true;
    if (item.path && BLOCKED_PATH_PREFIXES.some((p) => item.path.startsWith(p)))
      return true;
    return false;
  }

  function filterBlockedMenus(items) {
    if (!Array.isArray(items)) return items;
    return items
      .filter((item) => !isBlockedMenu(item))
      .map((item) =>
        item.children
          ? { ...item, children: filterBlockedMenus(item.children) }
          : item
      );
  }

  useEffect(() => {
    menuList().then((response) => {
      if (response && response.data && Array.isArray(response.data.Items)) {
        response.data.Items = filterBlockedMenus(response.data.Items);
      }
      const data = [response.data];
      setMenu(data);
      setMenuitems(data);

      setTimeout(() => {
        activateMenus(data);
      }, 100);

      setTimeout(() => {
        scrollToActiveMenuItem();
      }, 250);
    });
  }, []);

  useEffect(() => {
    history.push(location.pathname);
    if (history.length > 2) history.shift();

    if (history[0] !== history[1]) {
      activateMenus(menuitems);
      setTimeout(() => {
        scrollToActiveMenuItem();
      }, 100);
    }

    let mainContent = document.querySelector(".main-content");
    if (mainContent) {
      mainContent.addEventListener("click", mainContentClickFn);
      return () => mainContent.removeEventListener("click", mainContentClickFn);
    }
  }, [location, menuitems]);

  useEffect(() => {
    academyusergetdetail(localStorage.getItem("UID")).then((res) => {
      if (res.status === true && res.data.details.logo !== null) {
        setElogo(res.data.path + res.data.details.logo);
      }
    });

    if (document.body.classList.contains("horizontalmenu") && window.innerWidth >= 992) {
      clearMenuActive();
    }
  }, []);


  const menuIcontype = document.querySelector("body").classList.contains("horizontalmenu")
    ? "hor-icon"
    : "sidemenu-icon";

  function mainContentClickFn() {
    if (document.body.classList.contains("horizontalmenu") && window.innerWidth >= 992) {
      clearMenuActive();
    }
  }

  function activateMenus(items) {
    if (!items) return;

    items.forEach((mainlevel) => {
      if (!mainlevel.Items) return;

      mainlevel.Items.forEach((item) => {
        item.active = false;
        item.selected = false;

        let currentPath = location.pathname;
        if (currentPath.endsWith('/') && currentPath.length > 1) {
          currentPath = currentPath.slice(0, -1);
        }

        if (currentPath === "/superadmin/superdashboard/" || currentPath === "/superadmin/superdashboard") {
          currentPath = "/superadmin/superdashboard";
        }

        let itemPath = item.path;
        if (itemPath && itemPath.endsWith('/') && itemPath.length > 1) {
          itemPath = itemPath.slice(0, -1);
        }

        if (currentPath === itemPath) {
          item.active = true;
          item.selected = true;
        }

        if (item.children) {
          item.children.forEach((submenu) => {
            submenu.active = false;
            submenu.selected = false;

            let submenuPath = submenu.path;
            if (submenuPath && submenuPath.endsWith('/') && submenuPath.length > 1) {
              submenuPath = submenuPath.slice(0, -1);
            }

            if (currentPath === submenuPath) {
              item.active = true;
              item.selected = true;
              submenu.active = true;
              submenu.selected = true;
            }

            if (submenu.children) {
              submenu.children.forEach((submenu1) => {
                submenu1.active = false;
                submenu1.selected = false;

                let submenu1Path = submenu1.path;
                if (submenu1Path && submenu1Path.endsWith('/') && submenu1Path.length > 1) {
                  submenu1Path = submenu1Path.slice(0, -1);
                }

                if (currentPath === submenu1Path) {
                  item.active = true;
                  item.selected = true;
                  submenu.active = true;
                  submenu.selected = true;
                  submenu1.active = true;
                  submenu1.selected = true;
                }
              });
            }
          });
        }
      });
    });

    setMenuitems((arr) => [...arr]);
  }

  function toggleSidemenu(item) {
    if (!document.body.classList.contains("horizontalmenu-hover") || window.innerWidth < 992) {
      if (!item.active) {
        menuitems.forEach((mainlevel) => {
          if (!mainlevel.Items) return;
          mainlevel.Items.forEach((sublevel) => {
            sublevel.active = false;
            if (item === sublevel) {
              sublevel.active = true;
            }
            if (sublevel.children) {
              sublevel.children.forEach((sublevel1) => {
                sublevel1.active = false;
                if (item === sublevel1) {
                  sublevel.active = true;
                  sublevel1.active = true;
                }
                if (sublevel1.children) {
                  sublevel1.children.forEach((sublevel2) => {
                    sublevel2.active = false;
                    if (item === sublevel2) {
                      sublevel.active = true;
                      sublevel1.active = true;
                      sublevel2.active = true;
                    }
                  });
                }
              });
            }
          });
        });
      } else {
        item.active = !item.active;
      }
      setMenuitems((arr) => [...arr]);
    }
  }

  function clearMenuActive() {
    if (!menu) return;
    menu.forEach((mainlevel) => {
      if (!mainlevel.Items) return;
      mainlevel.Items.forEach((sublevel) => {
        sublevel.active = false;
        if (sublevel.children) {
          sublevel.children.forEach((sublevel1) => {
            sublevel1.active = false;
            if (sublevel1.children) {
              sublevel1.children.forEach((sublevel2) => {
                sublevel2.active = false;
              });
            }
          });
        }
      });
    });
    setMenuitems((arr) => [...arr]);
  }

  function Onhover() {
    const mainBody = document.querySelector(".main-body");
    if (mainBody && mainBody.classList.contains("main-sidebar-hide")) {
      mainBody.classList.add("main-sidebar-open");
    }
  }

  function Outhover() {
    const mainBody = document.querySelector(".main-body");
    if (mainBody) {
      mainBody.classList.remove("main-sidebar-open");
    }
  }

  function errorhandle(ev) {
    ev.target.src = require("../../../assets/images/logo/logo.png");
    ev.target.onerror = null;
  }

  function scrollToActiveMenuItem() {
    if (!scrollRef.current) return;
    const sidebar = scrollRef.current;

    // Target the top-level parent nav-item so items above viewport scroll into view
    const activeNavItem = sidebar.querySelector("li.nav-item.active");
    if (activeNavItem) {
      let offsetTop = 0;
      let el = activeNavItem;
      while (el && el !== sidebar) {
        offsetTop += el.offsetTop;
        el = el.offsetParent;
      }
      sidebar.scrollTo({ top: Math.max(0, offsetTop - 20), behavior: "smooth" });
    }
  }

  return (
    <Fragment>
      <div className="sticky" style={{ marginBottom: "-64px" }}>
        <div className="main-menu main-sidebar main-sidebar-sticky side-menu">
          <div className="main-container-1 active main-sidebar-header">
            <div
              className="hor-scroll sidebar-scroll-container"
              ref={scrollRef}
              style={{
                position: "relative", height: window.innerWidth < 992 ? "auto" : "100vh",
                maxHeight: window.innerWidth < 992 ? "calc(100vh - 60px)" : "100vh",
                overflowY: "auto"
              }}
            >
              <div className="sidemenu-logo">
                <Link className="main-logo" to={"/superadmin/superdashboard"}>
                  <img
                    src={elogo}
                    className="header-brand-img desktop-logo"
                    alt={"logo1"}
                    onError={errorhandle}
                  />
                  <img
                    src={elogo}
                    className="header-brand-img icon-logo"
                    alt={"logo-2"}
                  />
                  <img
                    src={elogo}
                    className="header-brand-img desktop-logo theme-logo"
                    alt={"logo-3"}
                    onError={errorhandle}
                  />
                  <img
                    src={elogo}
                    className="header-brand-img icon-logo theme-logo"
                    alt={"logo-4"}
                  />
                </Link>
              </div>
              <div
                className="main-body-1 main-sidebar-body"
                onMouseOver={Onhover}
                onMouseOut={Outhover}
              >
                <div className="slide-left">
                  <i className="fe fe-chevron-left"></i>
                </div>
                <ul className="menu-nav nav" style={{ marginLeft: "0px" }}>
                  {menuitems?.map((Item, itemi) => (
                    <Fragment key={itemi + Math.random() * 100}>
                      <li className="nav-header">
                        <span className="nav-label">{Item?.menutitle}</span>
                      </li>
                      {Item.Items.map((menuItem, i) => (
                        <li
                          className={`nav-item ${menuItem.selected ? "active" : ""}`}
                          key={i}
                        >
                          {menuItem.type === "sub" ? (
                            <a
                              className={"nav-link with-sub"}
                              onClick={(event) => {
                                event.preventDefault();
                                toggleSidemenu(menuItem);
                              }}
                              href="#!"
                            >
                              <span className="shape1"></span>
                              <span className="shape2"></span>
                              <i className={`${menuItem.icon} ${menuIcontype} menu-icon`}></i>
                              <span className="sidemenu-label">{menuItem.title}</span>
                              {menuItem.badge && (
                                <label className={menuItem.badge}>{menuItem.badgetxt}</label>
                              )}
                              <div className="according-menu">
                                {menuItem.active ? (
                                  <i className={`${menuItem.background} fa angle fa-angle-down`}></i>
                                ) : (
                                  <i className={`${menuItem.background} fa angle fa-angle-right`}></i>
                                )}
                              </div>
                            </a>
                          ) : null}

                          {menuItem.type === "link" ? (
                            <NavLink
                              to={menuItem.path + "/"}
                              className={`nav-link ${menuItem.selected ? " active" : ""}`}
                            >
                              <span className="shape1"></span>
                              <span className="shape2"></span>
                              <i className={`${menuItem.icon} ${menuIcontype} menu-icon`}></i>
                              <span className="sidemenu-label">{menuItem.title}</span>
                              {menuItem.badge && (
                                <label className={menuItem.badge}>{menuItem.badgetxt}</label>
                              )}
                            </NavLink>
                          ) : null}

                          {menuItem.children && (
                            <ul
                              className={`nav-sub ${menuItem.active ? "open" : ""}`}
                              style={menuItem.active ? { display: "block" } : { display: "none" }}
                            >
                              {menuItem.children.map((childrenItem, index) => (
                                <li
                                  key={index}
                                  className={`nav-sub-item ${childrenItem.selected ? "active show" : ""}`}
                                >
                                  {childrenItem.type === "sub" ? (
                                    <a
                                      href="#!"
                                      className="nav-sub-link sub-with-sub"
                                      onClick={(event) => {
                                        event.preventDefault();
                                        toggleSidemenu(childrenItem);
                                      }}
                                    >
                                      <span className="sidemenu-label">{childrenItem.title}</span>
                                      {childrenItem.active ? (
                                        <i className="angle fa fa-angle-down"></i>
                                      ) : (
                                        <i className={`${menuItem.background} fa angle fa-angle-right`}></i>
                                      )}
                                    </a>
                                  ) : null}

                                  {childrenItem.type === "link" ? (
                                    <NavLink to={childrenItem.path + "/"} className="nav-sub-link">
                                      {childrenItem.title}
                                    </NavLink>
                                  ) : null}

                                  {childrenItem.children && (
                                    <ul
                                      className="sub-nav-sub"
                                      style={childrenItem.active ? { display: "block" } : { display: "none" }}
                                    >
                                      {childrenItem.children.map((childrenSubItem, key) => (
                                        <li
                                          className={`nav-sub-item ${childrenSubItem.selected ? " active" : ""}`}
                                          key={key}
                                        >
                                          {childrenSubItem.type === "link" ? (
                                            <NavLink to={childrenSubItem.path + "/"} className="nav-sub-link">
                                              {childrenSubItem.title}
                                            </NavLink>
                                          ) : null}

                                          {childrenSubItem.type === "sub" ? (
                                            <Link
                                              to="#"
                                              className="nav-sub-item"
                                              onClick={(event) => {
                                                event.preventDefault();
                                                toggleSidemenu(childrenSubItem);
                                              }}
                                            >
                                              <span className="sidemenu-label">{childrenSubItem.title}</span>
                                              {childrenSubItem.active ? (
                                                <i className="fa fa-angle-down"></i>
                                              ) : (
                                                <i className="fa fa-angle-right"></i>
                                              )}
                                            </Link>
                                          ) : null}
                                        </li>
                                      ))}
                                    </ul>
                                  )}
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      ))}
                    </Fragment>
                  ))}
                </ul>
                <div className="slide-right">
                  <i className="fe fe-chevron-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="jumps-prevent" style={{ paddingTop: "64px" }}></div>
    </Fragment>
  );
};

export default SideBar;
